document.addEventListener('DOMContentLoaded', function() {
  // Select popup elements
  var popup = document.getElementById('rocketrez-popup');
  var closeBtn = document.querySelector('.rocketrez-close');
  
  // Función para abrir el popup
  function openPopup() {
      popup.style.display = 'block';
      document.body.classList.add('global-ticket-rocketrez-noscroll');
  }
  
  // Función para cerrar el popup
  function closePopup() {
      popup.style.display = 'none';
      document.body.classList.remove('global-ticket-rocketrez-noscroll');
  }
  
  // Abrir popup al hacer clic en botones con la clase específica
  document.addEventListener('click', function(event) {
      if (event.target.classList.contains('open-rocketrez-popup')) {
          openPopup();
      }
  });
  
  // Cerrar cuando se hace clic en el botón X
  closeBtn.addEventListener('click', function() {
      closePopup();
  });
  
  // Cerrar cuando se hace clic fuera del contenido del popup
  window.addEventListener('click', function(event) {
      if (event.target == popup) {
          closePopup();
      }
  });
  
  // Cerrar cuando se presiona la tecla Escape
  document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
          closePopup();
      }
  });
});